App.controller('showSurveyModalCtrl', ($scope, SurveySubmissions) => {
    $scope.loading = true
    $scope.survey = SurveySubmissions.$find($scope.ngDialogData.survey.uuid)
    $scope.survey.$promise.then( () => {
      $scope.loading = false
    })
})
